import { ROLLUP } from './admin.actions';
import * as CLOSURES from './closures-admin.actions';
import { FITTINGS } from './fittings-admin.actions';

export const ADMIN = Object.assign(ROLLUP, CLOSURES, FITTINGS);
